export default __webpack_public_path__ + "maps-examples-select-layer-thumbnail-960-55597f9cffbbe98dfe37e21216fe8937.png";